<se-fe-page [seFeDataLoaded]="true" SeFeDataWidth="full">

  <se-fe-header seFePageHeader [seFeDataTitle]="title" seFeDataSize="750">
  </se-fe-header>

  <se-fe-tab-group seFePageTabs [seFeDataTabPanel]="tabPanel">

    <se-fe-tab-item>
      <a [seFeTab]="true">Connections</a>
    </se-fe-tab-item>

  </se-fe-tab-group>


  <se-fe-tab-panel #tabPanel seFePageContent>
    <router-outlet></router-outlet>
  </se-fe-tab-panel>

</se-fe-page>
